"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Services.MetricCollectors
 */
/**
 * A session metric collector.
 */
var AbstractMetricCollector = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param name                       identity
     * @param exportToPrometheus         whether to expose the collector through the Prometheus gateway
     */
    function AbstractMetricCollector(name, exportToPrometheus) {
        this.name = name;
        this.exportToPrometheus = exportToPrometheus;
    }
    return AbstractMetricCollector;
}());
exports.AbstractMetricCollector = AbstractMetricCollector;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metric-collectors/abstract-metric-collector.js
// module id = 556
// module chunks = 1